
    const data = {"name":"src/core/icons/pause-box","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-8 13H9V8h2v8m4 0h-2V8h2v8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            